import { DropdownItemCombinedProps } from './types';

const usePresenter = (props: DropdownItemCombinedProps): DropdownItemCombinedProps => {
  return props;
};

export default usePresenter;
